import { render, staticRenderFns } from "./BlackWeekTeaser.vue?vue&type=template&id=6c1c2dfd&scoped=true"
import script from "./BlackWeekTeaser.vue?vue&type=script&lang=js"
export * from "./BlackWeekTeaser.vue?vue&type=script&lang=js"
import style0 from "./BlackWeekTeaser.vue?vue&type=style&index=0&id=6c1c2dfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c2dfd",
  null
  
)

export default component.exports